import { render, staticRenderFns } from "./Leave-Update.vue?vue&type=template&id=374a89bc"
import script from "./Leave-Update.vue?vue&type=script&lang=js"
export * from "./Leave-Update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports